<app-model-site-header [label]="'Edit profile'"></app-model-site-header>

<nb-card class="content-card profile">
  <nb-card-body class="profile__body">
    <app-profile-info class="profile__section"></app-profile-info>
    <app-change-password class="profile__section"></app-change-password>
  </nb-card-body>
</nb-card>
